<template>
    <div class="timer-wrap">
        <div class="label-wrap">
            <div v-if='active' class="activeMarker"></div>
            <label>{{label}}</label>
        </div>
        <div class="time-wrap">
            <span>{{this.getDisplayTime}}</span>
        </div>
        
    </div>
</template>

<script>
export default {
    props:{
        label:String,
        secondsValue:Number,
        active:Boolean,
    },
    data(){
        return{
            now: Date.now()/1000,
            timer:null,
        }
    },
    watch: { 
        active: function(newVal) { // watch it
            if(newVal == true){
                //console.log("active changed from false to true ",this.label);
                if(this.active){
                    //this.startTime = Date.now()/1000;
                    this.timer = setInterval(() => {
                        this.now = Date.now()/1000
                        //console.log("startTime: ", this.startTime);
                        //console.log("this.now: ",this.now)
                        //console.log("this.now - this.starttime: ",this.now -this.startTime)
                    },1000)
                }
            }else{
                //console.log("active changed from true to false", this.label);
                clearInterval(this.timer);
                //this.startTime = -1;
            }
        }
    },
    computed:{
        _seconds: () => 1,
        _minutes() {
            return this._seconds * 60;
        },
        _hours() {
            return this._minutes * 60;
        },
        getDisplayTime(){
            var secondsGes = this.secondsValue;
            //console.log("secondsGes: ",secondsGes);
            //console.log("this._hours: ",this._hours);
            if(this.active && this.now - this.startTime > 0){
                secondsGes= secondsGes + (this.now -this.startTime)
               //console.log("secondsGes2: ",secondsGes);
            }
            const hours = Math.floor(secondsGes  / this._hours);
            //console.log("hours: ",hours);
            const minutes = Math.floor((secondsGes % this._hours) / this._minutes);
            //console.log("minutes: ",minutes);
            const seconds = Math.floor((secondsGes % this._minutes) / this._seconds);
            //console.log("seconds: ",seconds);
            let displayHours = hours < 10 ? "0" + hours : hours;
            let displayMinutes = minutes < 10 ? "0" + minutes : minutes;
            let displaySeconds = seconds < 10 ? "0" + seconds : seconds;
            return displayHours + ":" + displayMinutes + ":" + displaySeconds;
        },
        startTime:{
            get(){
                return this.$store.state.local.nachtragTimer.startTimeActualTimer
            },
        }
    },
    mounted(){
        if(this.active)(
            this.timer = setInterval(() => {
                //console.log("startTime: ", this.startTime);
                this.now = Date.now()/1000
                //console.log("this.now: ",this.now)
            },1000)
        )
    },
    beforeDestroy(){
      clearInterval(this.timer);
    }
}
</script>

<style lang="scss" scoped>
    @import "@/assets/scss/styles.scss";
    .timer-wrap{
        display:flex;
        justify-content: space-between;
        padding: 3px 20px;
        font-size: 1.4rem;
        .label-wrap{
            position: relative;
        }
    }
    .activeMarker{
        width: 8px;
        height: 8px;
        border-radius: 6px;
        background-color: $trafficLightColorRed;
        margin:8px;
        display:inline-block;
        vertical-align: top;
        position: absolute;
        left:-20px;
        top:2px;
    }
</style>